import { connect } from 'react-redux';
import WeekdayFilter from './weekday-filter';
import { setFilterOption } from '../../../reducers/filter.reducers';

const mapStateToProps = state => ({
  selectedDaysOfWeek: state.filter.filterOptions.daysOfWeek,
});

const mapDispatchToProps = dispatch => ({
  setFilterOption: filterOption => dispatch(setFilterOption(filterOption)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WeekdayFilter);
